export default __webpack_public_path__ + "static/media/report.f16dc0a0.svg";